<template>
  <div class="page" v-if="activePage">
    <!-- TODO transiting between page types better -->
    <transition name="fade">
      <events v-if="activePage && activePage.type === 'events'"></events>
      <place
        v-if="activePage && activePage.type === 'place'"
        :isIssuuModalActive="isIssuuModalActive"
        @toggleIssuuModal="toggleIssuuModal"
      ></place>
    </transition>
    <right-sidebar
      :logo="$store.state.config.sidebarLogo"
      :minimap="activePage.minimapImage"
      :heading="activePage.heading[language.code]"
      :description="activePage.description[language.code]"
      :navigation-items="sidebarNavigationItems"
      :enable-slide-out="showQrCode"
    >
      <template slot="slide-out-slot">
        <div v-if="showQrCode" class="qr">
          <div class="qr__message">{{ activePage.qrMessage }}</div>
          <div class="qr__instruction">Please scan the QR code with your mobile device camera.</div>
          <qrcode-vue class="qrcode" :value="activePage.qrUrl" size="1000" renderAs="canvas"></qrcode-vue>
        </div>
      </template>
      <template slot="bottom-slot">
        <button v-if="activePage.issuuEmbedUrl" class="btn btn--blue touch" @click="toggleIssuuModal">{{ isIssuuModalActive ? 'Hide' : 'View' }} {{ activePage.issuuEmbedLabel}}</button>
      </template>
    </right-sidebar>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Events from '@/components/Events'
import Place from '@/components/Place'
import RightSidebar from '@/components/RightSidebar'
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'page',

  components: { Events, Place, RightSidebar, QrcodeVue },

  data () {
    return {
      animating: false,
      sidebarNavigationItems: [],
      isIssuuModalActive: false
    }
  },

  computed: {
    ...mapGetters([
      'activePage',
      'activeSubNavigation',
      'language'
    ]),

    showQrCode () {
      return Boolean(this.activePage.qrUrl.length && this.activePage.qrMessage.length)
    }
  },

  mounted () {
    this.updateSidebarNavigationItems()
    this.setSliderState()
  },

  watch: {
    $route () {
      this.isIssuuModalActive = false
    },

    activeSubNavigation () {
      this.updateSidebarNavigationItems()
    },

    activePage () {
      this.setSliderState()
    },

    language () {
      this.updateSidebarNavigationItems()
    }
  },

  methods: {
    setSliderState () {
      let isSliderPresent = false
      this.activePage.tags.forEach(tag => {
        if (tag.type === 'reference') {
          isSliderPresent = true
        }
      })
      this.$store.state.sidebar.isSliderPresent = isSliderPresent
    },

    updateSidebarNavigationItems () {
      let sidebarNavigationItems = []
      if (this.activeSubNavigation) {
        this.activeSubNavigation.forEach(_item => {
          let item = {
            to: this.$route.path.includes('live') ? `/live/page/${_item.pageId}` : `/category/${this.$store.state.route.params.categoryId}/page/${_item.pageId}`,
            label: _item.label[this.language.code],
            icon: _item.icon
          }
          sidebarNavigationItems.push(item)
        })
      }
      this.sidebarNavigationItems = sidebarNavigationItems      
    },

    toggleIssuuModal () {
      this.$store.commit('sidebar/CLOSE_SLIDEOUT')
      this.isIssuuModalActive = !this.isIssuuModalActive
    },
  }
}
</script>
<style lang="scss">
.place {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  &__image-container {
    height: 98rem;
    left: 0;
    position: absolute;
    top: 0;
    width: 152rem;
  }

  &__image {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
}

.qr {
  font-size: 1.6rem;
  line-height: 1.2;

  &__message {
    margin-bottom: 1em;
  }

  &__instruction {
    margin-bottom: 1em;
  }
}
</style>


